export default "__VITE_ASSET__Xel72DV2__"